var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReaderFingerPlugin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.998,
    height: 14,
    viewBox: "0 0 11.998 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4969",
    "data-name": "Path 4969",
    d: "M2.281,32.163A1.5,1.5,0,0,0,0,33.444v11a1.5,1.5,0,0,0,2.281,1.281l9-5.5a1.5,1.5,0,0,0,0-2.562Z",
    transform: "translate(0 -31.942)",
    fill: "#fcfcfc"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReaderFingerPlugin);
export default __webpack_public_path__ + "static/media/reader-finger-plugin.9d4c0a3e7deb20959ca53cff15517655.svg";
export { ForwardRef as ReactComponent };